<script lang="ts" setup>
const props = defineProps({
  data: Object as PropType<{
    title: string
    text: string
  }>,

})
const isOpen = ref(false)
</script>

<template>
  <div class="faq" :class="{ isOpen: isOpen }" v-if="data">
    <div class="faq__top" @click="isOpen = !isOpen">
      <div class="faq__title">{{ data.title }}</div>
      <div class="faq__toggle"></div>
    </div>
    <transition>
      <div class="faq__content" v-show="isOpen" v-html="data.text"></div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.faq {
  &.isOpen {
    .faq {
      &__toggle {
        &::after {
          transform: rotate(0);
        }
      }
    }
  }

  &__top {
    position: relative;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding-top: toRem(24);
    padding-bottom: toRem(24);
    border-top: 1px solid $color-gray-line;

    &:hover {
      .faq {
        &__title {
          color: $color-brand-3;
        }

        &__toggle {

          &::before,
          &::after {
            background-color: $color-brand-3;
          }
        }
      }
    }
  }

  &__title {
    padding-right: toRem(10);
    font-size: toRem(20);
    font-weight: 500;
    transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);

    @include max-media(480) {
      font-size: toRem(16);
    }
  }

  &__toggle {
    position: relative;
    flex-shrink: 0;
    width: toRem(18);
    height: toRem(18);
    margin-top: toRem(5);

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: toRem(-9);
      margin-top: toRem(-0.5);
      width: toRem(18);
      height: toRem(2);
      background-color: $color-black-1;
      transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);
    }

    &::after {
      transform: rotate(90deg);
    }
  }

  &__content {
    padding-bottom: toRem(25);
  }
}
</style>
